import React from 'react';
import VisibilitySensor from 'react-visibility-sensor';

import ArticleMetadata from '../ArticleMetadata/index.jsx';
import ArticleRender from '../ArticleRender/index.jsx';
import ArticleReaction from '../ArticleReaction/index.jsx';
import LockButton from '../LockButton/index.jsx';

class Article extends React.Component {
  constructor(props) {
    super(props);

    this.viewPage = this.viewPage.bind(this);
    this.sendAnalytics = this.sendAnalytics.bind(this);
  }

  viewPage(e) {
    e.preventDefault();
    var trigger = new CustomEvent('cs:article', {
      detail: {
        id: this.props.article.id.toString(),
        slug: this.props.article.slug,
        analytics: this.props.article.analytics,
      },
    });
    window.dispatchEvent(trigger);
  }

  sendAnalytics(isVisible) {
    if (isVisible) {
      CSAnalytics('Content Summary Seen', this.props.article.analytics);
    }
  }

  render() {
    var reactions;
    var article = this.props.article;

    if (article.reactions) {
      reactions = (
        <div className="cs-daily-posts-article__reactions">
          <ArticleReaction
            onReactionUpdate={(data) => {
              this.props.onUpdate(article, 'reaction', data);
            }}
            article={article}
          />
        </div>
      );
    }
    return (
      <VisibilitySensor
        onChange={this.sendAnalytics}
        partialVisibility={true}
        offset={{ bottom: 300, top: 300 }}
      >
        <div className="cs-daily-posts-article cs-daily-posts-article--headline">
          <div className="cs-daily-posts-article__meta">
            <ArticleMetadata article={article} />
          </div>
          <div className="cs-daily-posts-article__content">
            <ArticleRender article={article} />
            <div className="mt-3">
              <LockButton
                {...article}
                href={article.permalink}
                onClick={this.viewPage}
              >
                View Content
              </LockButton>
            </div>
          </div>
          {reactions}
        </div>
      </VisibilitySensor>
    );
  }
}

export default Article;
